export const pulse = (event) => {
    event.target.classList.remove('pulse-me');
    void event.target.offsetWidth;
    event.target.classList.add('pulse-me');
    // event.target.classList.remove('pulse-me');
}